import {
  tryJWTDecode,
  useAuthState,
  useCountry,
} from '@resurs-internal/rb-app-api';
import {ACR} from '../models/ACR';
import {useFeatureFlags} from './useFeatureFlags';

export const useShouldUserDoExtendedBankIdStep = (): boolean => {
  const auth = useAuthState();
  const country = useCountry();
  const flags = useFeatureFlags();

  const decodedToken = tryJWTDecode<{acr: string}>(auth.state.token);

  return (
    country.code === 'SE' &&
    flags.extendedBankIdEnabled &&
    (flags.forceExtendedBankId ||
      decodedToken?.acr === ACR.LOA_SUBSTANTIAL_RISK_MEDIUM)
  );
};
